export const CLIENT_PROGRAM_HOSTNAME = "shot-caller-production.herokuapp.com";
export const VIMEO_BASE_URL = "https://player.vimeo.com/video/";
